import React from 'react';
export function ImpressumPage() {
  return <div className="bg-white py-16" data-id="element-401">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-402">
        <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-403">Impressum</h1>

        <div className="space-y-8 text-gray-600" data-id="element-404">
          <section data-id="element-405">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-406">
              Angaben gemäß § 5 TMG
            </h2>
            <p data-id="element-407">
              Lissowski Glas- und Gebäudereinigung GmbH
              <br data-id="element-408" />
              Jülicher Straße 126
              <br data-id="element-409" />
              52070 Aachen
            </p>
          </section>

          <section data-id="element-410">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-411">
              Vertreten durch
            </h2>
            <p data-id="element-412">Uwe Böhme</p>
          </section>

          <section data-id="element-413">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-414">Kontakt</h2>
            <p data-id="element-415">
              Telefon: 0241 512746
              <br data-id="element-416" />
              E-Mail: buero@lissowski-gmbh.de
            </p>
          </section>

          <section data-id="element-417">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-418">
              Registereintrag
            </h2>
            <p data-id="element-419">
              Eintragung im Handelsregister.
              <br data-id="element-420" />
              Registergericht: Amtsgericht Aachen
              <br data-id="element-421" />
              Registernummer: HRB 2430
            </p>
          </section>

          <section data-id="element-422">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-423">
              Umsatzsteuer-ID
            </h2>
            <p data-id="element-424">
              Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
              <br data-id="element-425" />
              DE121683572
            </p>
          </section>

          <section data-id="element-426">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-427">
              Aufsichtsbehörde
            </h2>
            <p data-id="element-428">
              Handwerkskammer Aachen
              <br data-id="element-429" />
              Mitgliedsnummer: 3021542
            </p>
          </section>

          <section data-id="element-430">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-431">
              Berufshaftpflichtversicherung
            </h2>
            <p data-id="element-432">
              Gothaer
              <br data-id="element-433" />
              Marks & Schiffers
              <br data-id="element-434" />
              Brander Str. 4<br data-id="element-435" />
              52080 Aachen
              <br data-id="element-436" />
              Geltungsbereich: Europa
            </p>
          </section>

          <section className="pt-8 border-t border-gray-200" data-id="element-437">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-438">
              Streitschlichtung
            </h2>
            <p data-id="element-439">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:
              https://ec.europa.eu/consumers/odr.
              <br data-id="element-440" />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p className="mt-4" data-id="element-441">
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </section>
        </div>
      </div>
    </div>;
}